const mapToMonacoCompletionItem = range => item => {
  return {
    detail: item.additionalDetail,
    insertText: item.label,
    kind: item.kind,
    label: item.label,
    range
  };
};
export default mapToMonacoCompletionItem;